import React, { useEffect, useState } from 'react'
import * as styles from "./Main.module.scss";
import HeroSection from "./HeroSection.jsx";
import ProjectSynopsis from "./ProjectSynopsis.jsx";
import Gallery from "./Gallery.jsx";
import Location from "./Location.jsx";
import ProjectSpecs from "./ProjectSpecs.jsx";
import ProjectStatus from "./ProjectStatus.jsx";
import SitePlan from "./SitePlan.jsx";
import Layout from "../../common/Layout.js";
import Header from "./Header.jsx";
import Footer from '../../common/Footer.js';

function Main({ seoData }) {
  const [isClient, setIsClient] = useState(false);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(1);

  useEffect(() => {
    if(isClient) {
      window.addEventListener("scroll", () => {
        const section1Top = document.querySelector("#section-1")?.getBoundingClientRect().top;
        const section2Top = document.querySelector("#section-2")?.getBoundingClientRect().top;
        const section3Top = document.querySelector("#section-3")?.getBoundingClientRect().top;
        const section4Top = document.querySelector("#section-4")?.getBoundingClientRect().top;
        const section5Top = document.querySelector("#section-5")?.getBoundingClientRect().top;
        const section6Top = document.querySelector("#section-6")?.getBoundingClientRect().top;
        const section7Top = document.querySelector("#section-7")?.getBoundingClientRect().top;

        if(section1Top >= 0 && section1Top < window.innerHeight / 2) {
          setCurrentSectionIndex(1);
        }
        else if(section2Top >= 0 && section2Top < window.innerHeight / 2) {
          setCurrentSectionIndex(2);
        }
        else if(section3Top >= 0 && section3Top < window.innerHeight / 2) {
          setCurrentSectionIndex(3);
        }
        else if(section4Top >= 0 && section4Top < window.innerHeight / 2) {
          setCurrentSectionIndex(4);
        }
        else if(section5Top >= 0 && section5Top < window.innerHeight / 2) {
          setCurrentSectionIndex(5);
        }
        else if(section6Top >= 0 && section6Top < window.innerHeight / 2) {
          setCurrentSectionIndex(6);
        }
        else if(section7Top >= 0 && section7Top < window.innerHeight / 2) {
          setCurrentSectionIndex(7);
        }
      });
    }
  }, [isClient]);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <Layout seoData={seoData}>
      <Header currentSectionIndex={currentSectionIndex} setCurrentSectionIndex={setCurrentSectionIndex} />
      <div className={styles.main} id="srinivasa-main">
      <HeroSection />
      <ProjectSynopsis />
      <ProjectSpecs />
      <SitePlan currentSectionIndex={currentSectionIndex} />
      <Gallery />
      <ProjectStatus />
      <Location />
      {/* <Footer /> */}
      </div>
    </Layout>
  )
}

export default Main